import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import Header from '../../component/Header';
import Spinner from '../../component/Spinner';
import NavbarGA from '../../component/NavBarGA';
import AuthImage from '../../component/AuthImage';

function KaGAMonitoringGA() {

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [tick, setTick] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setTick(prev => prev + 1);
        }, 3 * 60 * 1000); // 3min

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!activeAccount) {
            navigate("/mesga");
        }
    }, [activeAccount]);

    useEffect(() => {
        (async () => {
            try {
                setIsShow(true);
            } catch (error) {
                console.log('error', error);
                alert(error.message);
            } finally {
                setIsShow(false);
            }
        })();
    }, [refresh]);

    return (
        <>
            <Spinner isShow={isShow} />
            <Header setRefresh={setRefresh} />
            <NavbarGA />
            <AuthImage filename="screenshot_monitor_1.png" alt="PBS Out" style={{ width: '100%' }} refreshTick={tick} />
            <AuthImage filename="screenshot_monitor_0.png" alt="Line" style={{ width: '100%' }} refreshTick={tick} />
        </>
    )
}

export default KaGAMonitoringGA;
